export const GROUP_NAME = 'switch'
